import React, { useRef, useState } from 'react';
import { Button } from '@material-ui/core';
import storageManager from '../utils/LocalStorageManager'
import player from '../utils/DefaultUserData'
import { Redirect } from 'react-router-dom'

const DataManagerButtons = (props) => {
    const inputFile = useRef(null)

    const [redirect, setRedirect] = useState(false)

    const onButtonClick = () => {
        // `current` points to the mounted file input element
        inputFile.current.click();
        console.log(inputFile.current)

    };

    const setFile = (e) => {
        let json;
        e.target.files[0].text().then(t => {
            json = JSON.parse(t)
            console.log(json)
            storageManager.updateDataFromFile(json)
            window.location.reload();
        })
    }



    return (
        <div>
            <Button onClick={() => { storageManager.updateData(player); window.location.reload(); }}>Start</Button>

            <Button onClick={() => storageManager.downloadData()}>Download Data</Button>

            <Button onClick={() => onButtonClick()}>Update Data</Button>
            <input type='file' id='file' accept=".json" ref={inputFile} style={{ display: 'none' }} onChange={(e) => setFile(e)} />

            <Button onClick={() => { storageManager.updateData(player); window.location.reload(); }}>Reset</Button>

            <Button onClick={() => setRedirect(true)}>Mestre</Button>
            {redirect ? <Redirect to="/mestre" /> : null}
            
        </div>
    );
}

export default DataManagerButtons;